/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import { isNumber } from "./common.js";
import {
  DEFAULT_PAYMENT_MINIMUM,
  MIN_RECURRING_OCCURRENCES,
  MAX_RECURRING_OCCURRENCES,
} from "../../config";

export const validPaymentInfo = {
  validAmount: (amount, min) => {
    let minNo = min;
    if (minNo === null) minNo = DEFAULT_PAYMENT_MINIMUM;
    return isNumber(amount, min);
  },
  validOccurrences: (o) => {
    return isNumber(
      o,
      MIN_RECURRING_OCCURRENCES,
      MAX_RECURRING_OCCURRENCES,
      true,
    );
  },
};
